import { AngebotsListenHttpService } from 'src/app/core/services/angebots-listen-http.service';
import { IndustriepartnerHttpService } from 'src/app/core/services/industriepartner-http.service';
import { ApothekenHttpService } from 'src/app/core/services/apotheken-http.service';
import { ReportingHttpService } from 'src/app/core/services/reporting-http.service';

export const environment = {
    production: true,
    angebotServiceUrl:
        'https://digibest.eu/digibest-dev/api/angebotsverwaltung-backend/',
    industriepartnerService: IndustriepartnerHttpService,
    angebotslistenService: AngebotsListenHttpService,
    apothekenService: ApothekenHttpService,
    showcaseUrl: 'https://digibest.eu/digibest-dev/bestellservice/msv3/',
    reportingPath: 'reporting/',
    reportingService: ReportingHttpService,
    isDemo: true
};
